// Données de test EN DUR pour la maquette frontend.
// (Remplacent temporairement les appels API le temps de valider le design.)

export const recipes = [
  {
    id: 1,
    name: 'Pancakes moelleux Tartina',
    description:
      "Des pancakes ultra moelleux nappés de Tartina fondante, le petit-déjeuner gourmand qui réveille toute la famille.",
    category: 'petit-déjeuner',
    occasions: ['weekend', 'rentrée scolaire'],
    prep_time: 20,
    estimated_cost: 2500,
    rating: 4.8,
    votes: 1284,
    author: 'Aïcha N.',
    tartina_quantity: '4 cuillères',
    image:
      'https://images.unsplash.com/photo-1528207776546-365bb710ee93?q=80&w=1000&auto=format&fit=crop',
    ingredients: [
      { name: 'Farine', quantity: '200', unit: 'g', cost: 400 },
      { name: 'Lait', quantity: '250', unit: 'ml', cost: 300 },
      { name: 'Œufs', quantity: '2', unit: '', cost: 400 },
      { name: 'Sucre', quantity: '30', unit: 'g', cost: 100 },
      { name: 'Levure chimique', quantity: '10', unit: 'g', cost: 200 },
      { name: 'Tartina', quantity: '4', unit: 'cuillères', cost: 800 },
    ],
    steps: [
      'Mélanger la farine, le sucre, la levure et une pincée de sel.',
      "Ajouter les œufs et le lait, mélanger jusqu'à obtenir une pâte lisse.",
      'Cuire de petites louches de pâte dans une poêle chaude.',
      'Retourner dès que des bulles apparaissent à la surface.',
      'Servir chaud avec une généreuse couche de Tartina.',
    ],
    tips: [
      'Ajoute des morceaux de banane dans la pâte pour plus de gourmandise.',
      'La Tartina se tartine mieux sur des pancakes tièdes.',
    ],
  },
  {
    id: 2,
    name: 'Tartines banane-Tartina',
    description:
      "Simple, rapide et économique : du pain de mie, des rondelles de banane et une généreuse couche de Tartina.",
    category: 'goûter',
    occasions: ['rentrée scolaire', 'weekend', 'picnic'],
    prep_time: 5,
    estimated_cost: 1200,
    rating: 4.5,
    votes: 932,
    author: 'Boris K.',
    tartina_quantity: '4 cuillères',
    image:
      'https://images.unsplash.com/photo-1484723091739-30a097e8f929?q=80&w=1000&auto=format&fit=crop',
    ingredients: [
      { name: 'Pain de mie', quantity: '4', unit: 'tranches', cost: 400 },
      { name: 'Bananes', quantity: '2', unit: '', cost: 400 },
      { name: 'Tartina', quantity: '4', unit: 'cuillères', cost: 400 },
    ],
    steps: [
      'Toaster légèrement les tranches de pain.',
      'Tartiner généreusement de Tartina.',
      'Disposer des rondelles de banane par-dessus.',
      'Option : saupoudrer de sucre glace ou de noix concassées.',
    ],
    tips: [
      'Quelques amandes effilées pour le croquant.',
      'Sers avec un verre de lait pour un goûter complet.',
    ],
  },
  {
    id: 3,
    name: 'Gâteau royal au Tartina',
    description:
      "Trois étages de biscuit cacao et une crème onctueuse au Tartina. Le dessert star des grandes occasions.",
    category: 'dessert',
    occasions: ['anniversaire', 'fête'],
    prep_time: 60,
    estimated_cost: 7500,
    rating: 5.0,
    votes: 2471,
    author: 'Mariam D.',
    tartina_quantity: '300 g',
    image:
      'https://images.unsplash.com/photo-1578985545062-69928b1d9587?q=80&w=1000&auto=format&fit=crop',
    ingredients: [
      { name: 'Farine', quantity: '300', unit: 'g', cost: 600 },
      { name: 'Beurre', quantity: '200', unit: 'g', cost: 1200 },
      { name: 'Sucre', quantity: '250', unit: 'g', cost: 500 },
      { name: 'Œufs', quantity: '4', unit: '', cost: 800 },
      { name: 'Chocolat noir', quantity: '100', unit: 'g', cost: 800 },
      { name: 'Crème fraîche', quantity: '200', unit: 'ml', cost: 1000 },
      { name: 'Tartina', quantity: '300', unit: 'g', cost: 2000 },
    ],
    steps: [
      'Mélanger le beurre et le sucre, puis ajouter les œufs.',
      'Incorporer la farine tamisée avec le cacao.',
      'Cuire trois disques de gâteau à 180°C pendant 20 minutes.',
      'Préparer la crème en mélangeant crème fraîche et Tartina.',
      'Superposer les disques avec la crème entre chaque couche.',
      'Napper le tout et décorer de chocolat râpé.',
    ],
    tips: [
      'Prépare-le la veille pour des saveurs plus intenses.',
      'Sors-le du frigo 30 minutes avant de servir.',
    ],
  },
  {
    id: 4,
    name: 'Milkshake Tartina',
    description:
      "Rafraîchissant et crémeux, ce milkshake au Tartina est parfait pour les journées chaudes.",
    category: 'goûter',
    occasions: ['picnic', 'weekend', 'fête'],
    prep_time: 10,
    estimated_cost: 1800,
    rating: 4.7,
    votes: 654,
    author: 'Sandrine M.',
    tartina_quantity: '3 cuillères',
    image:
      'https://images.unsplash.com/photo-1572490122747-3968b75cc699?q=80&w=1000&auto=format&fit=crop',
    ingredients: [
      { name: 'Lait', quantity: '250', unit: 'ml', cost: 300 },
      { name: 'Glaçons', quantity: '5', unit: '', cost: 0 },
      { name: 'Tartina', quantity: '3', unit: 'cuillères', cost: 600 },
      { name: 'Crème glacée vanille', quantity: '2', unit: 'boules', cost: 500 },
    ],
    steps: [
      'Mettre tous les ingrédients dans un blender.',
      "Mixer jusqu'à une texture homogène et crémeuse.",
      'Servir dans un grand verre avec une paille.',
      'Option : décorer de crème fouettée et de copeaux de chocolat.',
    ],
    tips: [
      'Utilise du lait bien froid pour plus de fraîcheur.',
      "Ajoute une banane pour plus d'épaisseur.",
    ],
  },
  {
    id: 5,
    name: 'Cookies cœur coulant Tartina',
    description:
      "Cookies moelleux à l'extérieur, cœur coulant de Tartina à l'intérieur. Irrésistibles au goûter.",
    category: 'goûter',
    occasions: ['fête', 'anniversaire', 'weekend'],
    prep_time: 40,
    estimated_cost: 3500,
    rating: 4.9,
    votes: 1876,
    author: 'Jean-Paul T.',
    tartina_quantity: '150 g',
    image:
      'https://images.unsplash.com/photo-1499636136210-6f4ee915583e?q=80&w=1000&auto=format&fit=crop',
    ingredients: [
      { name: 'Farine', quantity: '250', unit: 'g', cost: 500 },
      { name: 'Beurre', quantity: '125', unit: 'g', cost: 750 },
      { name: 'Sucre brun', quantity: '100', unit: 'g', cost: 300 },
      { name: 'Œuf', quantity: '1', unit: '', cost: 200 },
      { name: 'Chocolat en pépites', quantity: '100', unit: 'g', cost: 600 },
      { name: 'Tartina', quantity: '150', unit: 'g', cost: 900 },
    ],
    steps: [
      "Mélanger beurre mou et sucres jusqu'à un mélange crémeux.",
      "Ajouter l'œuf, puis la farine et la levure.",
      'Incorporer les pépites de chocolat.',
      'Former des boules, creuser un puits et y déposer la Tartina.',
      'Refermer puis cuire à 180°C pendant 10-12 minutes.',
    ],
    tips: [
      'Congèle la Tartina avant pour un cœur bien coulant.',
      'Laisse refroidir sur grille avant de déguster.',
    ],
  },
  {
    id: 6,
    name: 'Fondue de fruits au Tartina',
    description:
      "Une fondue express : Tartina tiédie au lait et une farandole de fruits frais à tremper. Léger et convivial.",
    category: 'dessert',
    occasions: ['picnic', 'fête'],
    prep_time: 15,
    estimated_cost: 2000,
    rating: 4.3,
    votes: 421,
    author: 'Esther W.',
    tartina_quantity: '200 g',
    image:
      'https://images.unsplash.com/photo-1541783245831-57d6fb0926d3?q=80&w=1000&auto=format&fit=crop',
    ingredients: [
      { name: 'Tartina', quantity: '200', unit: 'g', cost: 1200 },
      { name: 'Lait', quantity: '50', unit: 'ml', cost: 100 },
      { name: 'Bananes', quantity: '2', unit: '', cost: 400 },
      { name: 'Fraises', quantity: '200', unit: 'g', cost: 800 },
    ],
    steps: [
      'Faire chauffer doucement la Tartina avec le lait.',
      'Couper les fruits en morceaux.',
      'Disposer la sauce au centre, les fruits autour.',
      'Tremper les fruits à la fourchette à fondue.',
    ],
    tips: [
      'Une pointe de cannelle relève la sauce.',
      'La sauce ne doit pas être trop chaude.',
    ],
  },
  {
    id: 7,
    name: 'Brownie fondant Tartina',
    description:
      "Un brownie dense et fondant, gorgé de Tartina et de pépites de chocolat. Le réconfort absolu.",
    category: 'dessert',
    occasions: ['weekend', 'anniversaire'],
    prep_time: 35,
    estimated_cost: 4200,
    rating: 4.9,
    votes: 2058,
    author: 'Cédric A.',
    tartina_quantity: '250 g',
    image:
      'https://images.unsplash.com/photo-1564355808539-22fda35bed7e?q=80&w=1000&auto=format&fit=crop',
    ingredients: [
      { name: 'Chocolat noir', quantity: '200', unit: 'g', cost: 1500 },
      { name: 'Beurre', quantity: '150', unit: 'g', cost: 900 },
      { name: 'Sucre', quantity: '180', unit: 'g', cost: 350 },
      { name: 'Œufs', quantity: '3', unit: '', cost: 600 },
      { name: 'Tartina', quantity: '250', unit: 'g', cost: 850 },
    ],
    steps: [
      'Faire fondre le chocolat avec le beurre.',
      'Fouetter les œufs et le sucre, puis incorporer le chocolat.',
      'Ajouter la farine puis des cuillerées de Tartina.',
      'Cuire à 170°C pendant 22 minutes : le cœur reste fondant.',
    ],
    tips: [
      'Ne sur-cuis pas : le brownie fige en refroidissant.',
      'Sers tiède avec une boule de glace vanille.',
    ],
  },
  {
    id: 8,
    name: 'Crêpes roulées Tartina',
    description:
      "Des crêpes fines roulées et garnies de Tartina, à déguster chaudes. Un classique qui plaît à tous.",
    category: 'petit-déjeuner',
    occasions: ['weekend', 'rentrée scolaire'],
    prep_time: 25,
    estimated_cost: 1500,
    rating: 4.6,
    votes: 778,
    author: 'Larissa B.',
    tartina_quantity: '5 cuillères',
    image:
      'https://images.unsplash.com/photo-1519676867240-f03562e64548?q=80&w=1000&auto=format&fit=crop',
    ingredients: [
      { name: 'Farine', quantity: '250', unit: 'g', cost: 500 },
      { name: 'Lait', quantity: '500', unit: 'ml', cost: 600 },
      { name: 'Œufs', quantity: '3', unit: '', cost: 600 },
      { name: 'Tartina', quantity: '5', unit: 'cuillères', cost: 800 },
    ],
    steps: [
      'Préparer une pâte à crêpes lisse et la laisser reposer.',
      'Cuire des crêpes fines dans une poêle chaude.',
      'Tartiner de Tartina pendant que la crêpe est tiède.',
      'Rouler et servir aussitôt.',
    ],
    tips: [
      'Laisse reposer la pâte 30 minutes pour des crêpes souples.',
      'Saupoudre de sucre glace avant de servir.',
    ],
  },
];

// Sélections dérivées
export const topRated = [...recipes].sort((a, b) => b.rating - a.rating).slice(0, 4);
export const latest = [...recipes].sort((a, b) => b.id - a.id).slice(0, 4);
export const popular = [...recipes].sort((a, b) => b.votes - a.votes).slice(0, 4);

// Catégories et occasions
export const categories = [
  { key: 'petit-déjeuner', label: 'Petit-déjeuner', icon: 'ti-coffee', count: 86 },
  { key: 'dessert', label: 'Desserts', icon: 'ti-cake', count: 412 },
  { key: 'goûter', label: 'Goûters', icon: 'ti-cookie', count: 268 },
  { key: 'apéritif', label: 'Apéritifs', icon: 'ti-glass', count: 54 },
];

export const occasions = ['weekend', 'anniversaire', 'fête', 'rentrée scolaire', 'picnic'];

export const budgetPresets = [1500, 3000, 5000, 10000];

// Métadonnées du jeu-concours
export const contest = {
  title: 'Grand concours « Ma recette Tartina »',
  month: 'Juin',
  prize: '250 000 FCFA + 1 an de Tartina',
  deadline: '30 juin',
  participants: 318,
};

// Helpers (remplacent les requêtes côté maquette)
export const getRecipeById = (id) =>
  recipes.find((r) => String(r.id) === String(id)) || null;

export const filterRecipes = ({ query = '', category = '', occasion = '', maxCost = 0 } = {}) => {
  const q = query.trim().toLowerCase();
  return recipes.filter((r) => {
    if (q && !(`${r.name} ${r.description}`.toLowerCase().includes(q))) return false;
    if (category && r.category !== category) return false;
    if (occasion && !(r.occasions || []).includes(occasion)) return false;
    if (maxCost && r.estimated_cost > maxCost) return false;
    return true;
  });
};

const data = { recipes, topRated, latest, popular, categories, occasions, budgetPresets, contest };
export default data;
